/**
 * Labstep
 *
 * @module components/FilterPost/NewIndex/Device/Active/Post
 * @desc Active node component for Device
 */

import type { FilterPostActiveLabelProps } from 'labstep-web/components/FilterPost/Active/Label/types';
import { ICONS } from 'labstep-web/constants/icons';
import { RemoveLabel } from 'labstep-web/core/Label/Remove';
import { ReadOnMountHOC } from 'labstep-web/hoc/ReadOnMount';
import { Device } from 'labstep-web/models/device.model';
import { PostFilter } from 'labstep-web/services/postFilter';
import { PostFilterComparison } from 'labstep-web/services/postFilter/constants';
import type React from 'react';

export const FilterPostNewIndexDeviceActivePost: React.FC<
  FilterPostActiveLabelProps
> = ({ node, onRemoveClick }) => {
  const filter = new PostFilter(
    [['guid', PostFilterComparison.eq]],
    'experiments.protocolDevices.device',
  );
  const filterActive = filter.isNodeActive(node);
  if (!filterActive) {
    return null;
  }

  const attributes = filter.getAttributeValues(node);

  return (
    <ReadOnMountHOC
      entityName={Device.entityName}
      type="entities"
      params={{
        id: attributes.guid.value,
        get_single: 1,
      }}
      loading={false}
      children={({ entity }) => {
        if (!entity) {
          return null;
        }
        return (
          <RemoveLabel
            icon={ICONS.device.primary}
            name={entity.name}
            onRemoveClick={onRemoveClick}
          />
        );
      }}
    />
  );
};
